export function detectLang() {
  const lang = (navigator.language || navigator.userLanguage || "es").toLowerCase();
  if (lang === "pt-br") return "br";
  if (lang.startsWith("pt")) return "pt";
  if (lang.startsWith("en")) return "en";
  return "es";
}
